export default __webpack_public_path__ + "assets/models/ee17a6574c84c6768d15fd87474f0b19.glb";